import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import AdvancedCuestionMarker from "./AdvancedCuestionMarker";
import {
  setAdvancedSearchEnabled,
  setAssetType
} from "../../actions/AppAction";
import { getAdvancedSearchResult } from "../../actions/SearchAction";
import { getUsers } from "../../actions/UsersAction";
import classNames from "classnames/bind";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import { Select, DatePicker, Switch, Button, Icon } from "antd";
import { sendNotification } from "../../utils";
import "./advancedSearch.css";
import AudioIcon from "../../assets/icons/audio-icon.svg";
import FontIcon from "../../assets/icons/font-icon.svg";
import OthersIcon from "../../assets/icons/others-icon.svg";
import moment from "moment";

const { Option } = Select;

const { RangePicker } = DatePicker;

export class AdvancedSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      typeValues: [],
      nameValue: "",
      tagValues: [],
      extensionValue: "",

      userShow: [], // valores a mostrar para q componente pueda filtrar
      userValues: [], // ids seleccionados
      optionsUsers: [], // options

      stateAssetShow: [],
      stateAssetValues: [],
      optionsStatusAssets: [],

      mediaShow: [],
      mediaValues: [],
      optionsMedia: [],

      uuidValue: "",
      createDateValues: [],
      createDateMomentValues: [],

      locationValue: "",
      filterLocation: false
    };
  }

  componentDidMount() {
    const { workclient, statusAsset, media } = this.props;
    if (workclient) this.props.getUsers(workclient, 1);
    if (statusAsset) {
      this.setState({
        optionsStatusAssets: statusAsset.map(r => (
          <Option uid={r._id} key={r._id} value={r.title}>{`${r.title}`}</Option>
        ))
      })
    }
    if (media) {
      this.setState({
        optionsMedia: media.map(r => (
          <Option uid={r._id} key={r._id} value={r.title}>{`${r.title}`}</Option>
        ))
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      users,
      statusAsset,
      assetType,
      advancedSearchValuesFromNavbar
    } = this.props;
    if (prevProps.users !== users) {
      this.setState({
        optionsUsers: users.map((r, k) => (
          <Option
            key={k}
            name={r.name}
            email={r.email}
            value={r.name + r.email}
            uid={r._id}
          >
            {" "}
            {`${r.name} (${r.email})`}
          </Option>
        ))
      });
    }

    if (prevProps.statusAsset !== statusAsset) {
      this.setState({
        optionsStatusAssets: statusAsset.map(r => (
          <Option uid={r._id} key={r._id} value={r.title}>{`${r.title}`}</Option>
        ))
      });
    }

    if (prevProps.assetType !== assetType && typeof assetType === "string") {
      this.setState(
        {
          typeValues: [assetType]
        },
        () => {
          this.handleOnClickSearch();
        }
      );
      this.props.setAssetType(null);
    }

    if (
      prevProps.advancedSearchValuesFromNavbar !==
      advancedSearchValuesFromNavbar
    ) {
      if (advancedSearchValuesFromNavbar) {
        this.setState(
          {
            typeValues:
              advancedSearchValuesFromNavbar.searchType === "all"
                ? []
                : [advancedSearchValuesFromNavbar.searchType],
            nameValue: advancedSearchValuesFromNavbar.searchText,
            tagValues: [],
            extensionValue: "",
            userValues: [],
            userShow: [],
            stateAssetValues: [],
            stateAssetShow: [],
            mediaValues: [],
            mediaShow: [],
            uuidValue: "",
            createDateValues: [],
            createDateMomentValues: [],
            locationValue: "",
            filterLocation: false
          },
          () => this.handleOnClickSearch()
        );
      }
    }
  }

  handleOnClickType = item => {
    let { typeValues } = this.state;
    if (typeValues.includes(item))
      typeValues = typeValues.filter(r => r !== item);
    else typeValues.push(item);
    this.setState({ typeValues });
  };

  handleOnInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleOnChangeLocation = checked => {
    const { folderselect } = this.props;
    this.setState(prevState => ({
      filterLocation: checked,
      locationValue:
        checked && prevState.locationValue
          ? prevState.locationValue
          : checked && folderselect
            ? folderselect
            : ""
    }));
  };

  handleChangeTags = values => {
    this.setState({ tagValues: values });
  };

  handleChangeUsers = (values, items) => {
    this.setState({
      userShow: values,
      userValues: items.map(r => r.props.uid)
    });
  };

  handleChangeStateAsset = (values, items) => {
    this.setState({
      stateAssetShow: values,
      stateAssetValues: items.map(r => r.props.uid)
    });
  };

  handleChangeMedia = (values, items) => {
    this.setState({
      mediaShow: values,
      mediaValues: items.map(r => r.props.uid)
    });
  };

  handleChangeCreateDate = (value, dateString) => {
    this.setState({
      createDateMomentValues: value,
      createDateValues: dateString
    });
  };

  handleFolderSelect = folderId => {
    this.setState({ locationValue: folderId });
  };

  handleOnClickShowHide = () => {
    const { advancedSearchEnable } = this.props;
    this.props.setAdvancedSearchEnabled(!advancedSearchEnable);
  };

  handleOnClickCleanFilters = () => {
    this.setState({
      typeValues: [],
      nameValue: "",
      tagValues: [],
      extensionValue: "",
      userValues: [],
      userShow: [],
      stateAssetValues: [],
      stateAssetShow: [],
      mediaValues: [],
      mediaShow: [],
      uuidValue: "",
      createDateValues: [],
      createDateMomentValues: [],
      locationValue: "",
      filterLocation: false
    });
  };

  handleProcessParams = (name, values) => {
    return values.map(r => `&${name}=${r}`).join("");
  };

  handleOnClickSearch = () => {
    const {
      typeValues,
      nameValue,
      extensionValue,
      userValues,
      createDateValues,
      tagValues,
      mediaValues,
      stateAssetValues,
      locationValue,
      uuidValue
    } = this.state;
    const { workclient, intl } = this.props;
    if (
      typeValues.length === 0 &&
      nameValue.trim() === "" &&
      extensionValue.length === 0 &&
      userValues.length === 0 &&
      createDateValues.length === 0 &&
      tagValues.length === 0 &&
      mediaValues.length === 0 &&
      stateAssetValues.length === 0 &&
      locationValue === "" &&
      uuidValue === ""
    ) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "advanced_search_no_filters" })
      );
    } else {
      let url =
        typeValues.length > 0
          ? this.handleProcessParams("type", typeValues)
          : "";
      url += nameValue !== "" ? `&name=${nameValue.trim()}` : "";
      url += extensionValue !== "" ? `&assetExtension=${extensionValue}` : "";
      url +=
        userValues.length > 0
          ? this.handleProcessParams("user", userValues)
          : "";
      url +=
        createDateValues.length > 0 ? `&fromDate=${createDateValues[0]}` : "";
      url +=
        createDateValues.length > 0 ? `&toDate=${createDateValues[1]}` : "";
      url +=
        createDateValues.length > 0 ? `&offset=${moment().utcOffset()}` : "";
      url +=
        tagValues.length > 0 ? this.handleProcessParams("tags", tagValues) : "";
      url +=
        mediaValues.length > 0
          ? this.handleProcessParams("media", mediaValues)
          : "";
      url +=
        stateAssetValues.length > 0
          ? this.handleProcessParams("statusAsset", stateAssetValues)
          : "";
      url += locationValue !== "" ? `&location=${locationValue}` : "";
      url += uuidValue !== "" ? `&uuid=${uuidValue}` : "";
      this.props.getAdvancedSearchResult(workclient, url, 1, null, 40);
    }
  };

  render() {
    const {
      advancedSearchEnable,
      advancedSearchVisible,
      dartCustomField,
      user,
      intl,
      isAdvancedSearching,
      selectedFiles
    } = this.props;
    const {
      typeValues,
      nameValue,
      tagValues,
      extensionValue,
      userShow,
      uuidValue,
      createDateMomentValues,
      stateAssetShow,
      mediaShow
    } = this.state;
    const {
      optionsUsers,
      optionsStatusAssets,
      optionsMedia,
      filterLocation
    } = this.state;
    const classTypesVideo = classNames("bb-card-option", {
      "bb-card-option-active": typeValues.includes("video")
    });
    const classTypesImage = classNames("bb-card-option", {
      "bb-card-option-active": typeValues.includes("image")
    });
    const classTypesFolder = classNames("bb-card-option", {
      "bb-card-option-active": typeValues.includes("folder")
    });
    const classTypesDocument = classNames("bb-card-option", {
      "bb-card-option-active": typeValues.includes("document")
    });
    const classTypesFont = classNames("bb-card-option", {
      "bb-card-option-active": typeValues.includes("font")
    });
    const classTypesAudio = classNames("bb-card-option", {
      "bb-card-option-active": typeValues.includes("audio")
    });
    const classTypesOther = classNames("bb-card-option", {
      "bb-card-option-active": typeValues.includes("other")
    });
    const savedColor = localStorage.getItem("primaryColor");
    const MenuIcon = props => (
      <svg
        className="icon-settings"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.34621 6.37185H6.48495C6.74308 7.36817 7.6418 8.10938 8.71775 8.10938C9.79371 8.10938 10.6924 7.36817 10.9506 6.37185H18.6539C18.9724 6.37185 19.2308 6.11343 19.2308 5.79492C19.2308 5.47641 18.9724 5.218 18.6539 5.218H10.9506C10.6924 4.22167 9.79371 3.48047 8.71775 3.48047C7.6418 3.48047 6.74308 4.22167 6.48495 5.218H1.34621C1.0277 5.218 0.769287 5.47641 0.769287 5.79492C0.769287 6.11343 1.0277 6.37185 1.34621 6.37185ZM8.71775 4.63431C9.35778 4.63431 9.87836 5.1549 9.87836 5.79492C9.87836 6.43495 9.35778 6.95553 8.71775 6.95553C8.07773 6.95553 7.55715 6.43495 7.55715 5.79492C7.55715 5.1549 8.07773 4.63431 8.71775 4.63431Z"
          fill={props.fill}
        />
        <path
          d="M18.6539 9.83323H17.4184C17.1603 8.8369 16.2616 8.0957 15.1856 8.0957C14.1096 8.0957 13.2109 8.8369 12.9528 9.83323H1.34621C1.0277 9.83323 0.769287 10.0916 0.769287 10.4102C0.769287 10.7287 1.0277 10.9871 1.34621 10.9871H12.9528C13.2109 11.9834 14.1096 12.7246 15.1856 12.7246C16.2616 12.7246 17.1603 11.9834 17.4184 10.9871H18.6539C18.9724 10.9871 19.2308 10.7287 19.2308 10.4102C19.2308 10.0916 18.9724 9.83323 18.6539 9.83323ZM15.1856 11.5708C14.5456 11.5708 14.025 11.0502 14.025 10.4102C14.025 9.77013 14.5456 9.24955 15.1856 9.24955C15.8256 9.24955 16.3462 9.77013 16.3462 10.4102C16.3462 11.0502 15.8256 11.5708 15.1856 11.5708Z"
          fill={props.fill}
        />
        <path
          d="M18.6539 14.4485H7.47555C7.21746 13.4521 6.31879 12.7109 5.24345 12.7109C4.16749 12.7109 3.26877 13.4521 3.01064 14.4485H1.34621C1.0277 14.4485 0.769287 14.7069 0.769287 15.0254C0.769287 15.3439 1.0277 15.6023 1.34621 15.6023H3.01064C3.26877 16.5986 4.16749 17.3398 5.24345 17.3398C6.31879 17.3398 7.21746 16.5986 7.47555 15.6023H18.6539C18.9724 15.6023 19.2308 15.3439 19.2308 15.0254C19.2308 14.7069 18.9724 14.4485 18.6539 14.4485ZM5.24345 16.186C4.60342 16.186 4.08284 15.6654 4.08284 15.0254C4.08284 14.3854 4.60342 13.8648 5.24345 13.8648C5.88272 13.8648 6.4033 14.3854 6.4033 15.0254C6.4033 15.6654 5.88272 16.186 5.24345 16.186Z"
          fill={props.fill}
        />
      </svg>
    );

    return (
      <React.Fragment>
        {advancedSearchVisible && advancedSearchEnable && (
          <div className="bb-row-title filter-open" style={{ marginTop: 85 }}>
            <div className="bb-container">
              <div
                className="bb-title-link title-color-def"
                onClick={this.handleOnClickShowHide}
                style={{ width: "100%", cursor: "pointer" }}
              >
                <span>
                  <MenuIcon fill={savedColor} />
                </span>
                {intl.formatMessage({ id: "advanced_search_title" })}
                <div style={{ marginLeft: "80%" }}>
                  <Icon type="up" style={{ fontSize: 12 }} />
                </div>
              </div>
              <div className="bb-filters-options">
                <div className="bb-filters-box">
                  <div className="bb-filter-card">
                    <div className="bb-filter-card-title">
                      <p
                        style={{
                          color: "#526193",
                          fontWeight: "bold",
                          fontSize: 12
                        }}
                      >
                        {intl.formatMessage({ id: "advanced_search_format" })}
                      </p>
                      <AdvancedCuestionMarker
                        tooltip={intl.formatMessage({
                          id: "advanced_search_title_tooltip"
                        })}
                      />
                    </div>
                    <div className="bb-filter-card-options">
                      <div
                        className={classTypesVideo}
                        onClick={() => this.handleOnClickType(`video`)}
                      >
                        <span>
                          <svg
                            width="20"
                            height="16"
                            viewBox="0 0 20 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M17.6855 15.5H1.85221C0.931797 15.5 0.185547 14.7537 0.185547 13.8333V2.16667C0.185547 1.24625 0.931797 0.5 1.85221 0.5H17.6855C18.606 0.5 19.3522 1.24625 19.3522 2.16667V13.8333C19.3522 14.7537 18.606 15.5 17.6855 15.5ZM4.76888 1.33333H1.85221C1.39221 1.33333 1.01888 1.70667 1.01888 2.16667V3H4.76888V1.33333ZM9.35221 1.33333H5.60221V3H9.35221V1.33333ZM13.9355 1.33333H10.1855V3H13.9355V1.33333ZM18.5189 2.16667C18.5189 1.70667 18.1455 1.33333 17.6855 1.33333H14.7689V3H18.5189V2.16667ZM18.5189 3.83333H1.01888V12.1667H18.5189V3.83333ZM18.5189 13H14.7689V14.6667H13.9355V13H10.1855V14.6667H9.35221V13H5.60221V14.6667H4.76888V13H1.01888V13.8333C1.01888 14.2933 1.39221 14.6667 1.85221 14.6667H17.6855C18.1455 14.6667 18.5189 14.2933 18.5189 13.8333V13ZM8.77763 10.4021C8.70596 10.46 8.61805 10.5 8.51888 10.5C8.28846 10.5 8.10221 10.3137 8.10221 10.0833V5.91667C8.10221 5.68667 8.28846 5.5 8.51888 5.5C8.60763 5.5 8.68555 5.53417 8.75346 5.58167L11.9914 7.61167C12.1522 7.66875 12.2689 7.81917 12.2689 8C12.2689 8.13542 12.2001 8.25042 12.1001 8.32625L8.77763 10.4021Z"
                              fill="#526193"
                            />
                          </svg>
                        </span>
                        {intl.formatMessage({ id: "advanced_search_video" })}
                      </div>
                      <div
                        className={classTypesImage}
                        onClick={() => this.handleOnClickType(`image`)}
                      >
                        <span>
                          <svg
                            width="20"
                            height="16"
                            viewBox="0 0 20 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M18.269 15.0846H2.43571C1.51529 15.0846 0.769043 14.3384 0.769043 13.418V2.58464C0.769043 1.66422 1.51529 0.917969 2.43571 0.917969H18.269C19.1895 0.917969 19.9357 1.66422 19.9357 2.58464V13.418C19.9357 14.3384 19.1895 15.0846 18.269 15.0846ZM19.1024 2.58464C19.1024 2.12464 18.729 1.7513 18.269 1.7513H2.43571C1.97571 1.7513 1.60238 2.12464 1.60238 2.58464V13.418C1.60238 13.878 1.97571 14.2513 2.43571 14.2513H18.269C18.729 14.2513 19.1024 13.878 19.1024 13.418V2.58464ZM17.5749 12.4659L14.9357 9.82672L13.4278 11.3346L14.817 12.7238C14.9757 12.8826 14.9757 13.1401 14.817 13.2992C14.6578 13.458 14.4003 13.458 14.2415 13.2992L8.26904 7.32672L3.12988 12.4659C2.97113 12.6246 2.71363 12.6246 2.55446 12.4659C2.39571 12.3067 2.39571 12.0492 2.55446 11.8905L7.93154 6.51339C7.94488 6.49339 7.95363 6.4713 7.97113 6.45339C8.05321 6.3713 8.16154 6.3338 8.26904 6.3363C8.37654 6.3338 8.48488 6.3713 8.56696 6.45339C8.58446 6.4713 8.59279 6.49339 8.60654 6.51339L12.8524 10.7592L14.5982 9.01339C14.612 8.9938 14.6203 8.9713 14.6378 8.95339C14.7199 8.87172 14.8282 8.8338 14.9357 8.8363C15.0432 8.8338 15.1515 8.87172 15.2336 8.95339C15.2511 8.9713 15.2595 8.9938 15.2732 9.01339L18.1503 11.8905C18.309 12.0492 18.309 12.3067 18.1503 12.4659C17.9911 12.6246 17.7336 12.6246 17.5749 12.4659ZM12.4357 5.91797C11.5153 5.91797 10.769 5.17172 10.769 4.2513C10.769 3.33089 11.5153 2.58464 12.4357 2.58464C13.3561 2.58464 14.1024 3.33089 14.1024 4.2513C14.1024 5.17172 13.3561 5.91797 12.4357 5.91797ZM12.4357 3.41797C11.9757 3.41797 11.6024 3.7913 11.6024 4.2513C11.6024 4.7113 11.9757 5.08464 12.4357 5.08464C12.8957 5.08464 13.269 4.7113 13.269 4.2513C13.269 3.7913 12.8957 3.41797 12.4357 3.41797Z"
                              fill="#535361"
                            />
                          </svg>
                        </span>
                        {intl.formatMessage({ id: "advanced_search_image" })}
                      </div>
                      <div
                        className={classTypesFont}
                        onClick={() => this.handleOnClickType(`font`)}
                      >
                        <span>
                          <img src={FontIcon} alt="font" />
                        </span>
                        {intl.formatMessage({ id: "advanced_search_font" })}
                      </div>
                      <div
                        className={classTypesAudio}
                        onClick={() => this.handleOnClickType(`audio`)}
                      >
                        <span>
                          <img src={AudioIcon} alt="audio" />
                        </span>
                        {intl.formatMessage({ id: "advanced_search_audio" })}
                      </div>
                      <div
                        className={classTypesFolder}
                        onClick={() => this.handleOnClickType(`folder`)}
                      >
                        <span>
                          <svg
                            width="17"
                            height="14"
                            viewBox="0 0 17 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.1976 2.28571H9.57704L7.45876 0.167429C7.3519 0.0600001 7.20619 0 7.05476 0H1.34047C1.02504 0 0.769043 0.256 0.769043 0.571429C0.769043 0.886857 1.02504 1.14286 1.34047 1.14286H6.81819L8.93647 3.26114C9.04333 3.36857 9.18904 3.42857 9.34047 3.42857H15.6262V12.5714H1.9119V2.85714C1.9119 2.54171 1.6559 2.28571 1.34047 2.28571C1.02504 2.28571 0.769043 2.54171 0.769043 2.85714V13.1429C0.769043 13.4589 1.02504 13.7143 1.34047 13.7143H16.1976C16.5136 13.7143 16.769 13.4589 16.769 13.1429V2.85714C16.769 2.54171 16.5136 2.28571 16.1976 2.28571Z"
                              fill="#535361"
                            />
                          </svg>
                        </span>
                        {intl.formatMessage({ id: "advanced_search_folder" })}
                      </div>
                      <div
                        className={classTypesDocument}
                        onClick={() => this.handleOnClickType(`document`)}
                      >
                        <span>
                          <svg
                            width="15"
                            height="20"
                            viewBox="0 0 15 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13.1856 19.1667H2.35221C1.4318 19.1667 0.685547 18.4204 0.685547 17.5V1.66667C0.685547 0.74625 1.4318 0 2.35221 0H10.2576C10.2585 0 10.2597 0 10.2605 0H10.2689C10.4022 0 10.516 0.0670833 10.5922 0.164583L14.6876 4.26C14.7856 4.33625 14.8522 4.45 14.8522 4.58333V4.59208C14.8522 4.59292 14.8522 4.59333 14.8522 4.59417V17.5C14.8522 18.4204 14.106 19.1667 13.1856 19.1667ZM10.6856 1.40875V4.16667H13.4435L10.6856 1.40875ZM14.0189 5H10.2689C10.0385 5 9.85222 4.81333 9.85222 4.58333V0.833333H2.35221C1.89221 0.833333 1.51888 1.20667 1.51888 1.66667V17.5C1.51888 17.96 1.89221 18.3333 2.35221 18.3333H13.1856C13.6456 18.3333 14.0189 17.96 14.0189 17.5V5ZM11.5189 15.8333H4.01888C3.78846 15.8333 3.60221 15.6471 3.60221 15.4167C3.60221 15.1867 3.78846 15 4.01888 15H11.5189C11.7493 15 11.9356 15.1867 11.9356 15.4167C11.9356 15.6471 11.7493 15.8333 11.5189 15.8333ZM11.5189 12.5H4.01888C3.78846 12.5 3.60221 12.3137 3.60221 12.0833C3.60221 11.8533 3.78846 11.6667 4.01888 11.6667H11.5189C11.7493 11.6667 11.9356 11.8533 11.9356 12.0833C11.9356 12.3137 11.7493 12.5 11.5189 12.5ZM11.5189 9.16667H4.01888C3.78846 9.16667 3.60221 8.98042 3.60221 8.75C3.60221 8.52 3.78846 8.33333 4.01888 8.33333H11.5189C11.7493 8.33333 11.9356 8.52 11.9356 8.75C11.9356 8.98042 11.7493 9.16667 11.5189 9.16667Z"
                              fill="#535361"
                            />
                          </svg>
                        </span>
                        {intl.formatMessage({ id: "advanced_search_document" })}
                      </div>
                      <div
                        className={classTypesOther}
                        onClick={() => this.handleOnClickType(`other`)}
                      >
                        <span>
                          <img src={OthersIcon} alt="other" />
                        </span>
                        {intl.formatMessage({ id: "advanced_search_other" })}
                      </div>
                    </div>
                  </div>
                  <div className="bb-filter-card">
                    <div className="bb-filter-form">
                      <label htmlFor="#">
                        {intl.formatMessage({ id: "advanced_search_name" })}
                      </label>
                      <input
                        name="nameValue"
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "advanced_search_name_ph"
                        })}
                        value={nameValue}
                        onChange={this.handleOnInputChange}
                      />
                    </div>
                    <div className="bb-filter-form-select">
                      <label htmlFor="#">Tags</label>
                      <Select
                        mode="tags"
                        style={{ width: "65%" }}
                        placeholder={intl.formatMessage({
                          id: "advanced_search_tags_ph"
                        })}
                        onChange={this.handleChangeTags}
                        tokenSeparators={[","]}
                        value={tagValues}
                      ></Select>
                    </div>
                    <div className="bb-filter-form">
                      <label htmlFor="#">Extensión</label>
                      <input
                        name="extensionValue"
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "advanced_search_extension_ph"
                        })}
                        value={extensionValue}
                        onChange={this.handleOnInputChange}
                      />
                    </div>
                    <div className="bb-filter-form-select">
                      <label htmlFor="#">
                        {intl.formatMessage({ id: "advanced_search_user" })}
                      </label>
                      <Select
                        mode="multiple"
                        placeholder={intl.formatMessage({
                          id: "advanced_search_user_ph"
                        })}
                        style={{ width: "65%" }}
                        onChange={this.handleChangeUsers}
                        value={userShow}
                      >
                        {optionsUsers}
                      </Select>
                    </div>
                    {user.role === "admin" && (
                      <div className="bb-filter-form">
                        <label htmlFor="#">UUID</label>
                        <input
                          name="uuidValue"
                          type="text"
                          placeholder="uuid"
                          value={uuidValue}
                          onChange={this.handleOnInputChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="bb-filters-box">
                  <div className="bb-filter-form-date-picker">
                    <label htmlFor="#">
                      {intl.formatMessage({ id: "advanced_search_created_at" })}
                    </label>
                    <RangePicker
                      format="DD-MM-YYYY"
                      placeholder={[
                        intl.formatMessage({
                          id: "advanced_search_created_at_from_ph"
                        }),
                        intl.formatMessage({
                          id: "advanced_search_created_at_to_ph"
                        })
                      ]}
                      style={{ width: "65%" }}
                      onChange={this.handleChangeCreateDate}
                      value={createDateMomentValues}
                    />
                  </div>
                  <div className="bb-filter-form-select">
                    <label htmlFor="#">
                      {intl.formatMessage({ id: "advanced_search_state" })}
                    </label>
                    <Select
                      mode="multiple"
                      placeholder={intl.formatMessage({
                        id: "advanced_search_state_ph"
                      })}
                      style={{ width: "65%" }}
                      onChange={this.handleChangeStateAsset}
                      value={stateAssetShow}
                    >
                      {optionsStatusAssets}
                    </Select>
                  </div>
                  <div className="bb-filter-form-select">
                    <label htmlFor="#">{dartCustomField}</label>
                    <Select
                      mode="multiple"
                      placeholder={intl.formatMessage({
                        id: "advanced_search_seals_ph"
                      })}
                      style={{ width: "65%" }}
                      onChange={this.handleChangeMedia}
                      value={mediaShow}
                    >
                      {optionsMedia}
                    </Select>
                  </div>
                  <div className="bb-filter-form-location">
                    <label htmlFor="#">
                      {intl.formatMessage({ id: "advanced_search_location" })}
                    </label>
                    <div className="bb-filter-form-location-holder">
                      {!filterLocation && (
                        <input
                          type="text"
                          placeholder={intl.formatMessage({
                            id: "advanced_search_location_ph"
                          })}
                          readOnly
                        />
                      )}
                      {filterLocation && (
                        <Breadcrumb
                          placeholder={intl.formatMessage({
                            id: "advanced_search_location_ph"
                          })}
                          handleFolderSelect={this.handleFolderSelect}
                          changeFolder={false}
                        // permissionAware={(user.clientRole === 'admin' || user.role === 'admin') ? false : true}
                        // permissionsArray={['createFolder']}
                        />
                      )}

                      <Switch
                        checked={filterLocation}
                        onChange={this.handleOnChangeLocation}
                        checkedChildren={intl.formatMessage({ id: "yes" })}
                        unCheckedChildren="No"
                      />
                    </div>
                  </div>
                  <div className="bb-filter-buttons" style={{ marginTop: 80 }}>
                    <div onClick={this.handleOnClickShowHide}>
                      {intl.formatMessage({ id: "advanced_search_close" })}
                    </div>
                    <div onClick={this.handleOnClickCleanFilters}>
                      {intl.formatMessage({ id: "advanced_search_clean" })}
                    </div>
                    <Button
                      className="btn-go-filter"
                      type="primary"
                      loading={isAdvancedSearching}
                      onClick={this.handleOnClickSearch}
                    >
                      {intl.formatMessage({ id: "advanced_search_search" })}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {advancedSearchVisible &&
          !advancedSearchEnable &&
          selectedFiles.length <= 0 && (
            <div
              style={{
                width: "100%",
                height: 45,
                backgroundColor: "#E7E6E6",
                marginTop: 82,
                cursor: "pointer",
                padding: 1
              }}
            >
              <div className="container">
                <div
                  style={{ display: "flex", marginLeft: -10 }}
                  onClick={this.handleOnClickShowHide}
                >
                  {/* <img src="/images/icons/icon-filters.svg" alt='filtro'/> */}
                  <MenuIcon fill={savedColor} />
                  <span
                    className="title-color-def-1"
                    style={{
                      margin: 10,
                      // color: '#0096D6',
                      fontWeight: 700,
                      fontSize: 18,
                      opacity: 0.8
                    }}
                  >
                    {intl.formatMessage({ id: "advanced_search_title" })}
                  </span>
                </div>
              </div>
            </div>
          )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    advancedSearchEnable: state.app.advancedSearchEnable,
    advancedSearchVisible: state.app.advancedSearchVisible,
    advancedSearchValuesFromNavbar: state.app.advancedSearchValuesFromNavbar,
    assetType: state.app.assetType,
    workclient: state.client.workclient,
    users: state.users.data,
    statusAsset: state.client.data ? state.client.data.statusAsset : [],
    media: state.client.data ? state.client.data.media : null,
    dartCustomField: state.client.data ? state.client.data.dartCustomField : [],
    breadcrumb: state.client.breadcrumb,
    folderselect: state.assetsExplore.folderselect,
    user: state.authUser.user,
    page: state.searcher.page,
    isAdvancedSearching: state.searcher.isAdvancedSearching,
    limit: state.searcher.limit,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    selectedFiles: state.selectedFiles.data
  };
};

const mapDispatchToProps = {
  setAdvancedSearchEnabled,
  getAdvancedSearchResult,
  setAssetType,
  getUsers
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(AdvancedSearch))
);
